// Category catalog with colors + descriptions (matches the real Monyxx system)

// ─── Income categories ───
export const INCOME_CATEGORIES = [
  { id: "salario",    name: "Salário CLT",               color: "#10b981", bg: "bg-emerald-500/20",  text: "text-emerald-300" },
  { id: "freelance",  name: "Freelance / Autônomo",      color: "#06b6d4", bg: "bg-cyan-500/20",     text: "text-cyan-300" },
  { id: "aluguel",    name: "Aluguel",                   color: "#f59e0b", bg: "bg-amber-500/20",    text: "text-amber-300" },
  { id: "dividendos", name: "Dividendos / Invest.",      color: "#8b5cf6", bg: "bg-violet-500/20",   text: "text-violet-300" },
  { id: "beneficios", name: "Benefícios",                color: "#3b82f6", bg: "bg-blue-500/20",     text: "text-blue-300" },
  { id: "presente",   name: "Presente / Doação",         color: "#ec4899", bg: "bg-pink-500/20",     text: "text-pink-300" },
  { id: "reembolso",  name: "Reembolso",                 color: "#f97316", bg: "bg-orange-500/20",   text: "text-orange-300" },
  { id: "outros",     name: "Outros",                    color: "#64748b", bg: "bg-slate-500/20",    text: "text-slate-300" },
];

export const incCatById = (id) =>
  INCOME_CATEGORIES.find((c) => c.id === id) || INCOME_CATEGORIES[INCOME_CATEGORIES.length - 1];

// ─── Default categories (built-in) ───
export const DEFAULT_CATEGORIES = [
  { id: "mercado",       name: "Mercado",           color: "#f59e0b", bg: "bg-amber-500/20",    text: "text-amber-300",    desc: "Compras de supermercado, alimentos, produtos de limpeza e higiene do dia a dia." },
  { id: "necessidades",  name: "Necessidades",      color: "#f97316", bg: "bg-orange-500/20",   text: "text-orange-300",   desc: "Itens essenciais e inevitáveis (medicamentos, utilidades básicas)." },
  { id: "eletronicos",   name: "Eletrônicos",       color: "#3b82f6", bg: "bg-blue-500/20",     text: "text-blue-300",     desc: "Celulares, eletrodomésticos, acessórios e gadgets." },
  { id: "assinaturas",   name: "Assinaturas",       color: "#8b5cf6", bg: "bg-violet-500/20",   text: "text-violet-300",   desc: "Streaming, softwares, clubes e serviços recorrentes." },
  { id: "roupa",         name: "Roupa",             color: "#ec4899", bg: "bg-pink-500/20",     text: "text-pink-300",     desc: "Vestuário, calçados e acessórios de moda." },
  { id: "beleza",        name: "Beleza",            color: "#f43f5e", bg: "bg-rose-500/20",     text: "text-rose-300",     desc: "Cabeleireiro, cosméticos, manicure, estética." },
  { id: "eventuais",     name: "Despesas eventuais",color: "#eab308", bg: "bg-yellow-500/20",   text: "text-yellow-300",   desc: "Gastos não recorrentes, presentes, ocasiões específicas." },
  { id: "desenvolvimento",name:"Desenvolvimento",   color: "#06b6d4", bg: "bg-cyan-500/20",     text: "text-cyan-300",     desc: "Cursos, livros, mentorias, treinamentos." },
  { id: "transporte",    name: "Uber/Transporte",   color: "#22c55e", bg: "bg-green-500/20",    text: "text-green-300",    desc: "Uber, gasolina, manutenção veicular, transporte público." },
  { id: "ifood",         name: "iFood/Restaurantes",color: "#a855f7", bg: "bg-purple-500/20",   text: "text-purple-300",   desc: "Delivery, restaurantes, lanchonetes, cafeterias." },
  { id: "lazer",         name: "Lazer",             color: "#14b8a6", bg: "bg-teal-500/20",     text: "text-teal-300",     desc: "Viagens, passeios, cinema, entretenimento." },
  { id: "moradia",       name: "Moradia",           color: "#10b981", bg: "bg-emerald-500/20",  text: "text-emerald-300",  desc: "Aluguel, condomínio, IPTU, financiamento imobiliário." },
  { id: "casa",          name: "Casa",              color: "#64748b", bg: "bg-slate-500/20",    text: "text-slate-300",    desc: "Móveis, utilidades domésticas, reformas, manutenção." },
];

// Keep backward compat — CATEGORIES starts as defaults,
// but will be merged with custom ones via getCategories()
export let CATEGORIES = [...DEFAULT_CATEGORIES];

// Given a color hex, generate Tailwind-compatible bg/text classes
export const colorToClasses = (hex) => {
  // Map common hex ranges to tailwind
  return { bg: "bg-slate-500/20", text: "text-slate-300" };
};

// Merge defaults + custom categories from store
export const getCategories = (customCats = []) => {
  const merged = [...DEFAULT_CATEGORIES];
  for (const cc of customCats) {
    if (!merged.find((c) => c.id === cc.id)) {
      merged.push(cc);
    }
  }
  return merged;
};

export const catById = (id, customCats = []) => {
  const all = getCategories(customCats);
  return all.find((c) => c.id === id) || all[0];
};
